import React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";

export default function MenuItem({ active, item, icon, index }) {
  return (
    <li key={index.toString()} className={item.name === active ? "menu-btn-active" : "menu-btn"}>
      <Link to={`/${item.name}`} title={item.label}>
        <Icon title={item.label} icon={icon} size={20} height={20} stroke={item.name === active ? "#fff" : "#000"}/>
        <p>{item.label}</p>
      </Link>
    </li>
  );
}
